<div class="dashboard-container">
    <div class="chart-container-box">
        
        
        <!-- <div class="chart-card">
            <div class="pie-column">
                <div class="chart-title-label">Truck Assign/Unassign</div>
                <div class="chart-component">
                    <ngx-charts-pie-chart class="legend-title-style" [view]="chartViewFrame" [scheme]="colorScheme"
                        [results]="truckAssignData" [animations]="animations" [legend]="false"
                        [legendTitle]="legendTruckTitle" [legendPosition]="legendPosition"
                        [explodeSlices]="explodeSlices" [labels]="true" [doughnut]="doughnut"
                        [labelFormatting]="customAssignTruckLabel" [arcWidth]="arcWidth" [gradient]="gradient"
                        [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText" (dblclick)="dblclick($event)"
                        (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
                    </ngx-charts-pie-chart>
                    <div class="truck-status-container">
                        <div class="truck-status-title">Truck Status</div>
                        <div class="assigned-truck-status-container">
                            <div class="assigned-truck-status-color"></div>
                            <div class="truck-stauts-label">Assigned Truck</div>
                        </div>
                        <div class="assigned-truck-status-container">
                            <div class="unassigned-truck-status-color"></div>
                            <div class="truck-stauts-label">Unassign Truck</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="chart-card">
            <app-truck-status [frame]="chartViewFrame" [renderData]="truckAssignData"></app-truck-status>
        </div>
        <div class="chart-card">
            <div class="chart-title-label">Fuel Cost</div>
            <div class="chart-component-line">
                <ngx-charts-line-chart [view]="chartViewFrame" class="legend-title-style" [scheme]="colorScheme"
                    [schemeType]="schemeType" [results]="fuelCost" [animations]="animations" [legend]="false"
                    [legendTitle]="legendFuelCostTitle" [legendPosition]="legendPosition" [gradient]="gradient"
                    [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel"
                    [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabelFuelCost"
                    [yAxisLabel]="yAxisLabelFuelCost" [autoScale]="autoScale" [timeline]="timeline"
                    [showGridLines]="showGridLines" [curve]="curve" [rangeFillOpacity]="rangeFillOpacity"
                    [roundDomains]="roundDomains" [tooltipDisabled]="tooltipDisabled" [showRefLines]="showRefLines"
                    [showRefLabels]="showRefLabels" [referenceLines]="refLines" [trimXAxisTicks]="trimXAxisTicks"
                    [trimYAxisTicks]="trimYAxisTicks" [maxXAxisTickLength]="maxXAxisTickLength"
                    [maxYAxisTickLength]="maxYAxisTickLength" (select)="select($event)" (activate)="activate($event)"
                    (deactivate)="deactivate($event)">
                </ngx-charts-line-chart>
            </div>
        </div>

        <div class="chart-card">
            <div class="pie-column">
                <div class="chart-title-label">Service Maintenance</div>
                <div class="chart-component">
                    <ngx-charts-pie-chart class="legend-title-style" [view]="chartViewFrame" [scheme]="colorSchemeSM"
                        [results]="maintenaceServiceData" [animations]="animations" [legend]="false"
                        [legendTitle]="legendTruckTitle" [legendPosition]="legendPosition"
                        [explodeSlices]="explodeSlices" [labels]="true" [doughnut]="doughnut"
                        [labelFormatting]="maintenanceServiceLabel" [arcWidth]="arcWidth" [gradient]="gradient"
                        [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText" (dblclick)="dblclick($event)"
                        (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
                    </ngx-charts-pie-chart>
                    <div class="truck-status-container">
                        <div class="truck-status-title">Maintenance Status</div>
                        <div class="assigned-truck-status-container">
                            <div class="sm-overdue-status-color"></div>
                            <div class="truck-stauts-label">Overdue</div>
                        </div>
                        <div class="assigned-truck-status-container">
                            <div class="sm-due-soon-status-color"></div>
                            <div class="truck-stauts-label">Due Soon</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="chart-card">
            <div class="chart-title-label">On Time Service Compliant</div>
            <div class="chart-component-line">
                <ngx-charts-pie-grid class="chart-container" [view]="chartViewFrame" [scheme]="colorScheme" [results]="maintenaceServiceData"
                    [animations]="animations" [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText"
                    (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
                </ngx-charts-pie-grid>
            </div>
        </div>
        
    </div>
</div>

